import React from 'react'

import {
    Box,
    Image,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {motion} from 'framer-motion'
import {getUrl} from '../../../utils/cloudinary-utils'

const MotionBox = motion(Box)

const WishlistAnimation = () => {
    const styles = useMultiStyleConfig('ProductTileStyles')

    return (
        <Box position="absolute" right="42px" top="12px" zIndex={1}>
            <MotionBox
                top="-10px"
                left="7px"
                animate={{
                    opacity: [1, 0],
                    x: [0, 5],
                    y: [0, -10],
                    rotate: [0, 25]
                }}
                {...styles.motionBox}
            >
                <Image
                    src={getUrl('UIImages/images/fill-heart-icon.svg')}
                    alt="heart right"
                    width="100%"
                    height="100%"
                />
            </MotionBox>

            <MotionBox
                top="-11px"
                left="7px"
                animate={{
                    opacity: [1, 0],
                    x: [0, -7],
                    y: [0, -11],
                    rotate: [0, -25]
                }}
                {...styles.motionBox}
                transition={{duration: 0.7, ease: 'easeInOut'}}
            >
                <Image
                    src={getUrl('UIImages/images/fill-heart-icon.svg')}
                    alt="heart left"
                    width="100%"
                    height="100%"
                />
            </MotionBox>

            <MotionBox
                top="-20px"
                left="7px"
                animate={{
                    opacity: [1, 0],
                    x: [0, 4],
                    y: [0, -20],
                    rotate: [0, 20]
                }}
                {...styles.motionBox}
            >
                <Image
                    src={getUrl('UIImages/images/fill-heart-icon.svg')}
                    alt="heart top"
                    width="100%"
                    height="100%"
                />
            </MotionBox>
        </Box>
    )
}
export default WishlistAnimation
